// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./font.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme-primary: #FFE800;
  --theme-secondary: #4611a7;
  --theme-success: #1dae34;
  --theme-warning: #e28902;
  --theme-yellow: #F8D548;
  --theme-pink: #ff8d96;
  --white: #ffffff;
  --black: #000000;
  --black-shade1: #0a0e19;
  --color-333: #333333;
  --color-666: #666666;
  --color-959595: #959595;
  --color-d3d3d3: #d3d3d3;
  --color-marron: #6f1919;
  --light-gray: #e2e6f5;
  --gray-shade-1: #f2f4f5;
  --dark-blue: #11174d;
  --dark-blue-shade1: #1A2666;
  --dark-blue-shade2: #071334;
  --dark-blue-shade3: #101D49;
  --border-color: #d4d9e8;
  --theme-danger: #FF3D3D;
  --theme-danger-shade2: #cc3333;
  --lightest-blue-shade: #e7faff;
  --light-blue-shade: #2d344b;
  --light-blue-shade2: #c0d4da;
  --light-blue-shade3: #9bd1e8;
  --referral-blue-background: rgba(26, 7, 72, 1);
  --referral-blue-background2: rgba(70, 17, 167, 1);
  --referral-blue-background-opacity7: rgba(70, 17, 167, 0.7);
  --referral-black: rgba(0, 0, 0, 1);
  --referral-orange: rgba(229, 143, 40, 1);
  --referral-border-color: rgba(225, 230, 245, 1);
  --referral-border-color2: rgba(242, 244, 245, 1);
  --referral-border-color3: rgba(235, 231, 246, 1);
  --referral-light-gray: rgba(226, 230, 245, 1);
  --referral-yelllow: rgba(255, 232, 0, 1);
  --referral-gray: rgba(242, 244, 245, 1);
  --referral-cream: #fde8d4;
  --referral-black-shade: rgba(0, 0, 0, 0.1);
  --referral-orange-2:rgba(252, 182, 0, 1);
  --referral-pink: rgba(255, 83, 248, 1);
  --referral-green: rgba(29, 174, 52, 1);
  --referral-theme-danger: rgba(255, 61, 61, 1);
  --referral-gray-shade: rgba(51, 51, 51, 1);
  --referral-gray-shade2: rgba(211, 211, 211, 1);
  --referral-black-shade2: rgba(0, 0, 0, 0.2);
  --referral-gray-shade3: rgba(149, 149, 149, 1);
  --referral-orange-shade4: rgba(226, 137, 2, 0.2);
  --referral-gray-shade4: rgba(237, 240, 250, 1);
  --referral-gray-shade5: rgba(102, 102, 102, 1);
  --referral-green-opacity-5: rgba(29, 174, 52, 0.2);
  --referral-orange-shade-3:rgba(226, 137, 2, 1);
  --referral-orange-shade-4: rgba(204, 122, 0, 1);
  --referral-global-main-background: #F2F4F5;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

html {
  scroll-behavior: smooth;
}

html,
body {
  background: var(--white);
  overflow-x: hidden;
  font-family: "Inter", sans-serif;
}
#root {
  height: 100%;
}

.main {
  max-width: 500px;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}
.wpr100{
  width: 100%;
}
.fontSize8 {
  font-size: 8px;
  line-height: 9px;
}
.fontSizeXs {
  font-size: 10px;
  line-height: 12px;
}
.fontSize11 {
  font-size: 11px;
  line-height: 13px;
}
.fontSizeSm12 {
  font-size: 12px;
  line-height: 15px;
}
.fontSizeSm14 {
  font-size: 14px;
  line-height: 17px;
}
.fontSizeSm {
  font-size: 16px;
  line-height: 19px;
}
.fontSizeSm18 {
  font-size: 18px;
  line-height: 22px;
}
.fontSizeSm20 {
  font-size: 20px;
  line-height: 24px;
}
.fontSizeMd {
  font-size: 24px;
  line-height: 29px;
}
.fontSize32 {
  font-size: 32px;
  line-height: 38px;
}
.fontWeight900 {
  font-weight: 900;
}
.fontWeight800 {
  font-weight: 800;
}
.fontWeight700 {
  font-weight: 700;
}
.fontWeightBolder {
  font-weight: bold;
}
.fontWeightBold {
  font-weight: 600;
}
.fontWeightBoldImp {
  font-weight: 600 !important;
}
.fontWeightMedium {
  font-weight: 500;
}
.fonStyleItalic{
  font-style: italic;
}
.fontWeightRegular {
  font-weight: 400;
}
.fontColorWhite {
  color: var(--white);
}
.fontColorBlack {
  color: var(--black);
}
.fontColorBlackImp {
  color: var(--black) !important;
}
.fontColor333 {
  color: var(--color-333);
}
.fontColor959595 {
  color: var(--color-959595);
}
.fontColor666 {
  color: var(--color-666);
}
.fontColorSecondary {
  color: var(--theme-secondary);
}
.fontColorPrimary {
  color: var(--theme-primary);
}
.fontColorWarning {
  color: var(--theme-warning);
}
.fontColorSuccess {
  color: var(--theme-success);
}
.fontColorLightBlue{
  color: var(--light-blue-shade);
}
.fontColorDanger2 {
  color: var(--theme-danger-shade2);
}
.fontColorDarkBlue2 {
  color: var(--dark-blue-shade2);
}
.bgGray {
  background: var(--gray-shade-1);
}
.bgWhite {
  background: var(--white);
}
.textAlignLeft {
  text-align: left;
}
.textAlignCenter {
  text-align: center;
}
.textAlignRight {
  text-align: right;
}
.rotate180 {
  transform: rotate(180deg);
}
.noPadding {
  padding: 0px !important;
}
.textUppercase {
  text-transform: uppercase;
}
.stopscrolling {margin: 0; height: 100%; overflow: hidden}
.flex {
  display: flex;
}
.margbotm100{
  margin-bottom: 100px;
}
.inlineFlex {
  display: inline-flex;
}
.alignItemCenter {
  align-items: center;
}
.justifyContentCenter {
  justify-content: center;
}
.justifyContentSB {
  justify-content: space-between;
}
.justifyContentSA {
  justify-content: space-around;
}
.justifyContentFS {
  justify-content: flex-start;
}
.justifyContentFE {
  justify-content: flex-end;
}
.flexDirectionColumn {
  flex-direction: column;
}
.flexDirectionRow {
  flex-direction: row;
}
.relative {
  position: relative;
}
.relativeimp {
  position: relative !important;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.margauto{
  margin: auto;
}
.displayblock{
  display: block;
}
.gap10{
  gap: 10px;
}
.terms-and-conditions-page h2{
  font-size: 20px;
  font-weight: 600;
  color: var(--referral-black);
}
.terms-and-conditions-page p, .terms-and-conditions-page ul, .terms-and-conditions-page li, .terms-and-conditions-page span{
  font-size: 12px;
  color: var(--referral-black);
  margin-bottom: 10px;
  margin-top: 10px;
  line-height: 20px;
}
.terms-and-conditions-page ul, .terms-and-conditions-page ol{
  margin-left: 20px;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}
.noborder {
border-bottom: none !important;
}
.edit-withdrawal-amount-form .errorBox{
  display: flex;
  margin-top: 4px;
  padding-left: 0;
}

.mb10{
    margin-bottom: 10px;
  }
.mb20{
  margin-bottom: 20px;
}
.mbimp20{
  margin-bottom: 20px !important;
}
.mt5{
  margin-top: 5px;
}
.mt10{
  margin-top: 10px;
}
.mtimp10{
  margin-top: 10px !important;
}
.mt20{
  margin-top: 20px;
}
.mt50{
  margin-top: 50px;
}
.mt70{
  margin-top: 70px;
}

.gptblr10{
  padding: 10px;
}
.plr16{
  padding-left: 16px;
  padding-right: 16px;
}
.pt20{
  padding-top: 20px;
}
.pt10{
  padding-top: 10px;
}
.moveupwrapperdiv{
  display: block;
    position: absolute;
    top: -8px;
    padding-right: 7px;
    padding-left: 0;
    text-align: left;
    background-color: var(--white);
    left: 10px;
    padding-left: 7px;
      color: var(--referral-theme-danger);
}
.moveupwithouterrorwrapperdiv {
  display: block;
  position: absolute;
  top: -12px;
  padding-right: 7px;
  padding-left: 0;
  text-align: left;
  background-color: var(--white);
  left: 10px;
  padding-left: 7px;
  color: var(--black);
}
.closearrow{
  transform: rotate(180deg);
}
.gptblr20{
  padding: 20px;
  text-align: center;
}
.wimg100{
  width: 100%;
}
.gap5{
  gap: 5px;
}
.gap20{
  gap: 20px;
}
.successTag {
  position: relative;
  background: var(--theme-success);
  padding-left: 20px !important;
}
.errorBox_error{
  background-color: var(--referral-theme-danger) !important;
  color: var(--white) !important;
}
.errorBox_success{
  background-color: var(--theme-success) !important;
  color: var(--white) !important;
}
.successTag::before {
  content: "";
  position: absolute;
  display: block;
  left: 5px;
  top: 6px;
  width:5px;
  height: 5px;
  background: var(--white);
  border-radius: 100px;
  border: 1.5px solid var(--theme-success);
  z-index: 1;
}
.successTag::after {
  content: "";
  position: absolute;
  display: block;
  left: 4px;
  top: 5px;
  width:10px;
  height: 10px;
  background: var(--white);
  border-radius: 100px;
  z-index: 0;
}
.secondaryTag {
  background: var(--theme-secondary);
}
.refundTag {
  background: var(--black);
}
.refundTag-card .contentBox, 
.refundTag-card .entriesCount {
  opacity: 0.5;
}
.authPageContainer {
  position: relative;
  background: var(--color-333);
  padding: 15px;
  height: 100vh;
  height: 100dvh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.authContentBox { 
  position: relative;
 /* background: var(--white);*/
  border-radius: 20px;
  width: 100%;
  height: auto;
  padding: 20px;
}

.btn {
  width: 100%;
  min-height: 50px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 17px;
  color: var(--black);
  box-shadow: none;
  outline: none;
  border: none;
  cursor: pointer;
}
.btn.mdHeight {
  min-height: 42px;
}
.btn:disabled {
  background: var(--color-959595);
  color: rgba(0,0,0, 0.5);
  pointer-events: none;
}
.primaryBtn {
  background: var(--theme-primary);
  color: var(--theme-secondary);
}
.secondaryBtn {
  background: transparent;
  color: var(--theme-secondary);
  border: 1px solid var(--theme-secondary);
}
.darkBlackBtn {
  background: rgba(10, 14, 25, 1);
  color: var(--white);
  box-shadow: 0px 4px 8px rgba(42, 59, 91, 1);
}
.darkBlackBorderBtn {
  border: 2px solid rgba(10, 14, 25, 1);
  color: rgba(10, 14, 25, 1);
  background: transparent;
}
.pageWrapper {
  position: relative;
  top: 68px;
  height: auto;
  width: 100%;
  padding: 20px 15px 80px;
  margin: 0px 0px 70px;
  background: var(--gray-shade-1);
}
.pageWrapper.noHeader {
  margin-top: 0px;
  padding-bottom: 70px;
  top: 0px;
}

/* Chrome, Safari, Edge, Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.positionabsolute{
  position: absolute;
}
.bottom0{
  bottom: 0;
}
.bottom15{
  bottom: 15px;
}
.right0{
  right: 0;
}
.left0{
  left: 0;
}
.recomPad{
  padding: 4px 8px;
  border-radius: 7px;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.hexagonShapeWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: linear-gradient(180.26deg, rgba(192, 220, 233, 0) 73.41%, rgba(192, 220, 233, 0.65) 99.77%);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  transform: translate(0px, 2.5px);
  position: relative;
  z-index: 1;
}

.home-page,
.tournament-details-leaderboard-page,
.download-page,
.how-to-play-page,
.help-page,
.game-history-page {
  background: var(--gray-shade-1);
}
.game-history-page .pageWrapper {
  padding-bottom: 20px;
  margin: 0px;
}

/* for Mobile only */
@media (max-width: 767px) {
  .Toastify__toast {
    border-radius: 12px;
    max-width: calc(100vw - 20px);
    margin: 0px auto 10px;
  }
  .Toastify__toast-body {
    margin: 0px;
    padding: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,8CAA8C;EAC9C,iDAAiD;EACjD,2DAA2D;EAC3D,kCAAkC;EAClC,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;EACzB,0CAA0C;EAC1C,wCAAwC;EACxC,sCAAsC;EACtC,sCAAsC;EACtC,6CAA6C;EAC7C,0CAA0C;EAC1C,8CAA8C;EAC9C,2CAA2C;EAC3C,8CAA8C;EAC9C,gDAAgD;EAChD,8CAA8C;EAC9C,8CAA8C;EAC9C,kDAAkD;EAClD,8CAA8C;EAC9C,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA,gBAAgB,SAAS,EAAE,YAAY,EAAE,gBAAgB;AACzD;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;;IAEI,aAAa;IACb,wBAAwB;AAC5B;AACA;AACA,8BAA8B;AAC9B;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;IACI,mBAAmB;EACrB;AACF;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;IACZ,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,UAAU;IACV,iBAAiB;MACf,mCAAmC;AACzC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,yDAAyD;EACzD,8BAA8B;AAChC;AACA;EACE,iDAAiD;EACjD,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,QAAQ;EACR,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,wCAAwC;EACxC,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;CACnB,6BAA6B;EAC5B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,QAAQ;AACV;;AAEA,gCAAgC;AAChC;;EAGE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,QAAQ;AACV;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uGAAuG;EACvG,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;;EAME,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["@import \"./font.css\";\n\n:root {\n  --theme-primary: #FFE800;\n  --theme-secondary: #4611a7;\n  --theme-success: #1dae34;\n  --theme-warning: #e28902;\n  --theme-yellow: #F8D548;\n  --theme-pink: #ff8d96;\n  --white: #ffffff;\n  --black: #000000;\n  --black-shade1: #0a0e19;\n  --color-333: #333333;\n  --color-666: #666666;\n  --color-959595: #959595;\n  --color-d3d3d3: #d3d3d3;\n  --color-marron: #6f1919;\n  --light-gray: #e2e6f5;\n  --gray-shade-1: #f2f4f5;\n  --dark-blue: #11174d;\n  --dark-blue-shade1: #1A2666;\n  --dark-blue-shade2: #071334;\n  --dark-blue-shade3: #101D49;\n  --border-color: #d4d9e8;\n  --theme-danger: #FF3D3D;\n  --theme-danger-shade2: #cc3333;\n  --lightest-blue-shade: #e7faff;\n  --light-blue-shade: #2d344b;\n  --light-blue-shade2: #c0d4da;\n  --light-blue-shade3: #9bd1e8;\n  --referral-blue-background: rgba(26, 7, 72, 1);\n  --referral-blue-background2: rgba(70, 17, 167, 1);\n  --referral-blue-background-opacity7: rgba(70, 17, 167, 0.7);\n  --referral-black: rgba(0, 0, 0, 1);\n  --referral-orange: rgba(229, 143, 40, 1);\n  --referral-border-color: rgba(225, 230, 245, 1);\n  --referral-border-color2: rgba(242, 244, 245, 1);\n  --referral-border-color3: rgba(235, 231, 246, 1);\n  --referral-light-gray: rgba(226, 230, 245, 1);\n  --referral-yelllow: rgba(255, 232, 0, 1);\n  --referral-gray: rgba(242, 244, 245, 1);\n  --referral-cream: #fde8d4;\n  --referral-black-shade: rgba(0, 0, 0, 0.1);\n  --referral-orange-2:rgba(252, 182, 0, 1);\n  --referral-pink: rgba(255, 83, 248, 1);\n  --referral-green: rgba(29, 174, 52, 1);\n  --referral-theme-danger: rgba(255, 61, 61, 1);\n  --referral-gray-shade: rgba(51, 51, 51, 1);\n  --referral-gray-shade2: rgba(211, 211, 211, 1);\n  --referral-black-shade2: rgba(0, 0, 0, 0.2);\n  --referral-gray-shade3: rgba(149, 149, 149, 1);\n  --referral-orange-shade4: rgba(226, 137, 2, 0.2);\n  --referral-gray-shade4: rgba(237, 240, 250, 1);\n  --referral-gray-shade5: rgba(102, 102, 102, 1);\n  --referral-green-opacity-5: rgba(29, 174, 52, 0.2);\n  --referral-orange-shade-3:rgba(226, 137, 2, 1);\n  --referral-orange-shade-4: rgba(204, 122, 0, 1);\n  --referral-global-main-background: #F2F4F5;\n}\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nhtml,\nbody {\n  background: var(--white);\n  overflow-x: hidden;\n  font-family: \"Inter\", sans-serif;\n}\n#root {\n  height: 100%;\n}\n\n.main {\n  max-width: 500px;\n  margin: 0 auto;\n  height: 100%;\n  width: 100%;\n}\n.wpr100{\n  width: 100%;\n}\n.fontSize8 {\n  font-size: 8px;\n  line-height: 9px;\n}\n.fontSizeXs {\n  font-size: 10px;\n  line-height: 12px;\n}\n.fontSize11 {\n  font-size: 11px;\n  line-height: 13px;\n}\n.fontSizeSm12 {\n  font-size: 12px;\n  line-height: 15px;\n}\n.fontSizeSm14 {\n  font-size: 14px;\n  line-height: 17px;\n}\n.fontSizeSm {\n  font-size: 16px;\n  line-height: 19px;\n}\n.fontSizeSm18 {\n  font-size: 18px;\n  line-height: 22px;\n}\n.fontSizeSm20 {\n  font-size: 20px;\n  line-height: 24px;\n}\n.fontSizeMd {\n  font-size: 24px;\n  line-height: 29px;\n}\n.fontSize32 {\n  font-size: 32px;\n  line-height: 38px;\n}\n.fontWeight900 {\n  font-weight: 900;\n}\n.fontWeight800 {\n  font-weight: 800;\n}\n.fontWeight700 {\n  font-weight: 700;\n}\n.fontWeightBolder {\n  font-weight: bold;\n}\n.fontWeightBold {\n  font-weight: 600;\n}\n.fontWeightBoldImp {\n  font-weight: 600 !important;\n}\n.fontWeightMedium {\n  font-weight: 500;\n}\n.fonStyleItalic{\n  font-style: italic;\n}\n.fontWeightRegular {\n  font-weight: 400;\n}\n.fontColorWhite {\n  color: var(--white);\n}\n.fontColorBlack {\n  color: var(--black);\n}\n.fontColorBlackImp {\n  color: var(--black) !important;\n}\n.fontColor333 {\n  color: var(--color-333);\n}\n.fontColor959595 {\n  color: var(--color-959595);\n}\n.fontColor666 {\n  color: var(--color-666);\n}\n.fontColorSecondary {\n  color: var(--theme-secondary);\n}\n.fontColorPrimary {\n  color: var(--theme-primary);\n}\n.fontColorWarning {\n  color: var(--theme-warning);\n}\n.fontColorSuccess {\n  color: var(--theme-success);\n}\n.fontColorLightBlue{\n  color: var(--light-blue-shade);\n}\n.fontColorDanger2 {\n  color: var(--theme-danger-shade2);\n}\n.fontColorDarkBlue2 {\n  color: var(--dark-blue-shade2);\n}\n.bgGray {\n  background: var(--gray-shade-1);\n}\n.bgWhite {\n  background: var(--white);\n}\n.textAlignLeft {\n  text-align: left;\n}\n.textAlignCenter {\n  text-align: center;\n}\n.textAlignRight {\n  text-align: right;\n}\n.rotate180 {\n  transform: rotate(180deg);\n}\n.noPadding {\n  padding: 0px !important;\n}\n.textUppercase {\n  text-transform: uppercase;\n}\n.stopscrolling {margin: 0; height: 100%; overflow: hidden}\n.flex {\n  display: flex;\n}\n.margbotm100{\n  margin-bottom: 100px;\n}\n.inlineFlex {\n  display: inline-flex;\n}\n.alignItemCenter {\n  align-items: center;\n}\n.justifyContentCenter {\n  justify-content: center;\n}\n.justifyContentSB {\n  justify-content: space-between;\n}\n.justifyContentSA {\n  justify-content: space-around;\n}\n.justifyContentFS {\n  justify-content: flex-start;\n}\n.justifyContentFE {\n  justify-content: flex-end;\n}\n.flexDirectionColumn {\n  flex-direction: column;\n}\n.flexDirectionRow {\n  flex-direction: row;\n}\n.relative {\n  position: relative;\n}\n.relativeimp {\n  position: relative !important;\n}\n.absolute {\n  position: absolute;\n}\n.fixed {\n  position: fixed;\n}\n.margauto{\n  margin: auto;\n}\n.displayblock{\n  display: block;\n}\n.gap10{\n  gap: 10px;\n}\n.terms-and-conditions-page h2{\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--referral-black);\n}\n.terms-and-conditions-page p, .terms-and-conditions-page ul, .terms-and-conditions-page li, .terms-and-conditions-page span{\n  font-size: 12px;\n  color: var(--referral-black);\n  margin-bottom: 10px;\n  margin-top: 10px;\n  line-height: 20px;\n}\n.terms-and-conditions-page ul, .terms-and-conditions-page ol{\n  margin-left: 20px;\n}\n\ninput[type=\"date\"]::-webkit-inner-spin-button,\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n}\n.noborder {\nborder-bottom: none !important;\n}\n.edit-withdrawal-amount-form .errorBox{\n  display: flex;\n  margin-top: 4px;\n  padding-left: 0;\n}\n\n.mb10{\n    margin-bottom: 10px;\n  }\n.mb20{\n  margin-bottom: 20px;\n}\n.mbimp20{\n  margin-bottom: 20px !important;\n}\n.mt5{\n  margin-top: 5px;\n}\n.mt10{\n  margin-top: 10px;\n}\n.mtimp10{\n  margin-top: 10px !important;\n}\n.mt20{\n  margin-top: 20px;\n}\n.mt50{\n  margin-top: 50px;\n}\n.mt70{\n  margin-top: 70px;\n}\n\n.gptblr10{\n  padding: 10px;\n}\n.plr16{\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.pt20{\n  padding-top: 20px;\n}\n.pt10{\n  padding-top: 10px;\n}\n.moveupwrapperdiv{\n  display: block;\n    position: absolute;\n    top: -8px;\n    padding-right: 7px;\n    padding-left: 0;\n    text-align: left;\n    background-color: var(--white);\n    left: 10px;\n    padding-left: 7px;\n      color: var(--referral-theme-danger);\n}\n.moveupwithouterrorwrapperdiv {\n  display: block;\n  position: absolute;\n  top: -12px;\n  padding-right: 7px;\n  padding-left: 0;\n  text-align: left;\n  background-color: var(--white);\n  left: 10px;\n  padding-left: 7px;\n  color: var(--black);\n}\n.closearrow{\n  transform: rotate(180deg);\n}\n.gptblr20{\n  padding: 20px;\n  text-align: center;\n}\n.wimg100{\n  width: 100%;\n}\n.gap5{\n  gap: 5px;\n}\n.gap20{\n  gap: 20px;\n}\n.successTag {\n  position: relative;\n  background: var(--theme-success);\n  padding-left: 20px !important;\n}\n.errorBox_error{\n  background-color: var(--referral-theme-danger) !important;\n  color: var(--white) !important;\n}\n.errorBox_success{\n  background-color: var(--theme-success) !important;\n  color: var(--white) !important;\n}\n.successTag::before {\n  content: \"\";\n  position: absolute;\n  display: block;\n  left: 5px;\n  top: 6px;\n  width:5px;\n  height: 5px;\n  background: var(--white);\n  border-radius: 100px;\n  border: 1.5px solid var(--theme-success);\n  z-index: 1;\n}\n.successTag::after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  left: 4px;\n  top: 5px;\n  width:10px;\n  height: 10px;\n  background: var(--white);\n  border-radius: 100px;\n  z-index: 0;\n}\n.secondaryTag {\n  background: var(--theme-secondary);\n}\n.refundTag {\n  background: var(--black);\n}\n.refundTag-card .contentBox, \n.refundTag-card .entriesCount {\n  opacity: 0.5;\n}\n.authPageContainer {\n  position: relative;\n  background: var(--color-333);\n  padding: 15px;\n  height: 100vh;\n  height: 100dvh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.authContentBox { \n  position: relative;\n /* background: var(--white);*/\n  border-radius: 20px;\n  width: 100%;\n  height: auto;\n  padding: 20px;\n}\n\n.btn {\n  width: 100%;\n  min-height: 50px;\n  border-radius: 40px;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 17px;\n  color: var(--black);\n  box-shadow: none;\n  outline: none;\n  border: none;\n  cursor: pointer;\n}\n.btn.mdHeight {\n  min-height: 42px;\n}\n.btn:disabled {\n  background: var(--color-959595);\n  color: rgba(0,0,0, 0.5);\n  pointer-events: none;\n}\n.primaryBtn {\n  background: var(--theme-primary);\n  color: var(--theme-secondary);\n}\n.secondaryBtn {\n  background: transparent;\n  color: var(--theme-secondary);\n  border: 1px solid var(--theme-secondary);\n}\n.darkBlackBtn {\n  background: rgba(10, 14, 25, 1);\n  color: var(--white);\n  box-shadow: 0px 4px 8px rgba(42, 59, 91, 1);\n}\n.darkBlackBorderBtn {\n  border: 2px solid rgba(10, 14, 25, 1);\n  color: rgba(10, 14, 25, 1);\n  background: transparent;\n}\n.pageWrapper {\n  position: relative;\n  top: 68px;\n  height: auto;\n  width: 100%;\n  padding: 20px 15px 80px;\n  margin: 0px 0px 70px;\n  background: var(--gray-shade-1);\n}\n.pageWrapper.noHeader {\n  margin-top: 0px;\n  padding-bottom: 70px;\n  top: 0px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.positionabsolute{\n  position: absolute;\n}\n.bottom0{\n  bottom: 0;\n}\n.bottom15{\n  bottom: 15px;\n}\n.right0{\n  right: 0;\n}\n.left0{\n  left: 0;\n}\n.recomPad{\n  padding: 4px 8px;\n  border-radius: 7px;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.hexagonShapeWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background: linear-gradient(180.26deg, rgba(192, 220, 233, 0) 73.41%, rgba(192, 220, 233, 0.65) 99.77%);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n  transform: translate(0px, 2.5px);\n  position: relative;\n  z-index: 1;\n}\n\n.home-page,\n.tournament-details-leaderboard-page,\n.download-page,\n.how-to-play-page,\n.help-page,\n.game-history-page {\n  background: var(--gray-shade-1);\n}\n.game-history-page .pageWrapper {\n  padding-bottom: 20px;\n  margin: 0px;\n}\n\n/* for Mobile only */\n@media (max-width: 767px) {\n  .Toastify__toast {\n    border-radius: 12px;\n    max-width: calc(100vw - 20px);\n    margin: 0px auto 10px;\n  }\n  .Toastify__toast-body {\n    margin: 0px;\n    padding: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
